import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TranslationService {
  languageChange: EventEmitter<void> = new EventEmitter<void>();
  
  private _translations: any;

  get translations(): any {
    return this._translations;
  }

  set translations(value: any) {
    this._translations = value;
  }

  notifyLanguageChange() {
    this.languageChange.emit();
  }
}